import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m5.499 8.61.218.197-.07.311c-.33 1.447-.494 2.17-.119 2.455s.982-.102 2.197-.876l.266-.17.267.17c1.214.774 1.821 1.161 2.196.876s.211-1.008-.118-2.455l-.068-.298.233-.209c1.08-.968 1.62-1.452 1.476-1.913-.143-.462-.852-.522-2.27-.641l-.3-.026-.123-.305c-.547-1.373-.82-2.06-1.284-2.06s-.737.687-1.284 2.06l-.122.305-.301.026c-1.418.12-2.127.18-2.27.64-.144.462.396.946 1.476 1.914"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M3.216 3.74C2.32 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.291 5.524 14.1 8 14.1s3.925-.809 4.784-1.84C13.68 11.184 14.1 9.667 14.1 8s-.42-3.184-1.316-4.26C11.924 2.709 10.476 1.9 8 1.9s-3.925.809-4.784 1.84"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
StarCircleOutlinedSize16Glyph.displayName = 'StarCircleOutlinedSize16Glyph';
